import { Capacitor } from '@capacitor/core';

// Arms/disarms the live-update rollback as early as possible.
//
// The plugin starts a native `readyTimeout` countdown the moment an OTA bundle
// is activated; if `ready()` has not been called by then, the bundle is assumed
// broken and the app is reset to the one shipped in the App Store binary.
// This therefore MUST NOT wait on anything network-bound — `middleware/auth.global.js`
// awaits `fetchUser()` during the first navigation, so anything running from a
// component's `onMounted` is transitively gated on a round-trip and would roll
// back perfectly good bundles for users on slow connections.
export default defineNuxtPlugin(() => {
  if (import.meta.dev || !useRuntimeConfig().public.isIOSApp || Capacitor.getPlatform() !== 'ios') {
    return;
  }

  return {
    provide: {
      // Resolved by CapacitorOtaUpdate.vue, which reports the outcome once the
      // Sentry plugin has initialised. Deliberately never rejects: the component
      // awaits it before doing anything else, so a rejection here would take the
      // whole update check down with it.
      otaReady: useOtaUpdate.markReady().catch((error) => {
        console.error('[OTA] ready() failed', error);
        return null;
      }),
    },
  };
});
